/** Avatars (emoji) proposés à la création et à la modification du profil. */
export const STUDENT_AVATARS = ["🦊", "🐼", "🦉", "🐯", "🐸", "🦄", "🐙", "🦁"];
export const PARENT_AVATARS = ["👩", "👨", "🧑", "👩‍🦱", "👨‍🦳", "🧔", "👵", "👴"];
